import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

import { useGame } from "./components/header/GameContext";

import ScrollTotop from "./scrollToTop";

import HintOverlay from "./components/header/HintOverlay";

//Compornts
import Intro from "./components/intro/imgText3Button";
import ChatBox from "./components/chat/chat";
import Place from "./components/place/place";
import LoginName from "./components/login/loginOne";
import Tutorial from "./components/tutorial/tutorial";
import Suspect from "./components/suspect/suspect";
import Quize from "./components/quize/quize";
import Wrong from "./components/wrong/wrong";
import Keyword from "./components/keywordInput/keyword";
import Answer from "./components/answer/answer";
import Wait from "./components/wait/wait";
import Ranking from "./components/ranking/ranking";
import Clear from "./components/clear/clear";
import Survey from "./components/survey/survey";

import Adm from "./components/adm/index";

//CSS
import "./index.css";

//IMG import
import tutorial1 from "./img/tutorial/tutorial-1.png";
import tutorial2 from "./img/tutorial/tutorial-2.png";
import tutorial3 from "./img/tutorial/tutorial-3.png";
import HintContainer from "./components/header/HintContainer.js";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const { suspectImgs } = useGame();

  const [nameText, setNameText] = useState("");
  const [introTeam, setIntroTeam] = useState("");
  const [introInCode, setIntroInCode] = useState("");
  const [introUserRole, setIntroUserRole] = useState("");

  const handleFinish = ({ route, defaultPath, state }) => {
    navigate(route || defaultPath, {
      state,
    });
  };

  return (
    <>
      <ScrollTotop />
      <HintOverlay />
      <Routes>
        <Route
          path="/"
          element={
            <Intro
              handleName={introTeam}
              setHandleName={setIntroTeam}
              handleName2={introInCode}
              setHandleName2={setIntroInCode}
              handleName3={introUserRole}
              setHandleName3={setIntroUserRole}
              onFinish={handleFinish}
              defaultPath="/login"
            />
          }
        />
        <Route
          path="/login"
          element={
            <LoginName
              handleName={nameText}
              setHandleName={setNameText}
              onFinish={handleFinish}
              defaultPath="/story"
            />
          }
        />
        <Route
          path="/story"
          element={
            <ChatBox
              DateVal={"intro1"}
              titImgClass={"infoTit"}
              onFinish={handleFinish}
              defaultPath="/tutorial"
              timerMode="pause"
            />
          }
        />
        <Route
          path="/tutorial"
          element={
            <Tutorial
              tutorialImgs={[tutorial1, tutorial2, tutorial3]}
              onFinish={handleFinish}
              defaultPath="/suspect"
              timerMode="pause"
            />
          }
        />
        <Route
          path="/suspect"
          element={
            <Suspect
              suspectImgs={suspectImgs}
              isHintMode={false}
              onFinish={handleFinish}
              defaultPath="/story2"
              timerMode="pause"
            />
          }
        />
        <Route
          path="/story2"
          element={
            <ChatBox
              DateVal={"intro2"}
              titImgClass={"infoTit"}
              onFinish={handleFinish}
              defaultPath="/keywordInput"
              timerMode="pause"
            />
          }
        />
        <Route
          path="/keywordInput"
          element={
            <Keyword
              answerData={"keyword"}
              DateVal={"keyword"}
              titImgclassName={"infoTit"}
              hintWhetherIs={false}
              hintContent={""}
              timerMode="run"
            />
          }
        />
        <Route
          path="/info"
          element={
            <ChatBox
              key={location.key}
              onFinish={handleFinish}
              defaultPath="/keywordInput"
              timerMode="pause"
            />
          }
        />
        <Route
          path="/place"
          element={
            <Place
              key={location.key}
              onFinish={handleFinish}
              defaultPath="/keywordInput"
              timerMode="run"
            />
          }
        />
        <Route path="/quiz" element={<Quize key={location.key} />} />
        <Route path="/hint" element={<HintContainer />} />
        <Route path="/wrong" element={<Wrong />} />
        <Route path="/answer" element={<Answer key={location.key} />} />
        <Route path="/wait" element={<Wait />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/clear" element={<Clear />} timerMode="pause" />
        <Route path="/survey/:step" element={<Survey />} />

        {/* 관리자 */}
        <Route path="/adm" element={<Adm />} />
        {/* 관리자 END*/}
      </Routes>
    </>
  );
}

//  <Quize
//    answerData={"keyword"}
//    DateVal={"DATA3"}
//    titImgclassName={"infoTit"}
//    hintWhetherIs={false}
//    hintContent={""}
//  />;
